/**
 * Dictionnaire FR → EN pour l'API TheMealDB (Assistant Vide-Frigo)
 * Une entrée par ligne pour faciliter la lecture (~50 lignes par bloc)
 */

export const translationsFRtoEN = {
  poulet: "chicken",
  poulets: "chicken",
  volaille: "chicken",
  boeuf: "beef",
  bœuf: "beef",
  viande: "beef",
  porc: "pork",
  cochon: "pork",
  poisson: "fish",
  saumon: "salmon",
  thon: "tuna",
  crevettes: "prawns",
  canard: "duck",
  dinde: "turkey",
  agneau: "lamb",
  veau: "veal",
  tomate: "tomato",
  tomates: "tomato",
  oignon: "onion",
  oignons: "onion",
  ail: "garlic",
  aulx: "garlic",
  carotte: "carrot",
  carottes: "carrot",
  "pomme de terre": "potato",
  "pommes de terre": "potato",
  patate: "potato",
  patates: "potato",
  courgette: "zucchini",
  courgettes: "zucchini",
  aubergine: "eggplant",
  aubergines: "eggplant",
  poivron: "pepper",
  poivrons: "pepper",
  champignon: "mushroom",
  champignons: "mushroom",
  epinards: "spinach",
  epinard: "spinach",
  salade: "lettuce",
  laitue: "lettuce",
  concombre: "cucumber",
  haricots: "beans",
  haricot: "beans",
  pois: "peas",
  mais: "corn",
  chou: "cabbage",
  brocoli: "broccoli",
};
